export default __webpack_public_path__ + "static/madura.header.mobile-a6419412f6607e7d7328dfa82f963bd8.jpg";